export const openingHours = {
    startTime: 8,
    endTime: 17
}
